import React, { useEffect, useRef, useState } from 'react';
import './style.scss';

const VolumeIndicator = ({ powerLevel = 0, barCount = 20, width = 400, height = 50 }) => {
    const containerRef = useRef();
    const [activeBars, setActiveBars] = useState(0);

    useEffect(() => {
        // 根据音量级别计算应该高亮的矩形数量
        // powerLevel 通常在 0-100 之间，我们需要映射到 0-barCount
        const normalizedLevel = Math.max(0, Math.min(100, powerLevel));
        const activeCount = Math.floor((normalizedLevel / 100) * barCount);
        setActiveBars(activeCount);
    }, [powerLevel, barCount]);

    // 生成矩形条
    const renderBars = () => {
        const bars = [];
        // const barWidth = (width - (barCount - 1) * 2) / barCount; // 减去间距
        const barWidth = 14;
        
        for (let i = 0; i < barCount; i++) {
            const isActive = i < activeBars;
            // 根据位置设置不同的颜色强度
            const intensity = (i + 1) / barCount;
            
            bars.push(
                <div
                    key={i}
                    className={`volume-bar ${isActive ? 'active' : ''}`}
                    style={{
                        width: `${barWidth}px`,
                        height: `${height}px`,
                        '--intensity': intensity,
                        '--bar-index': i
                    }}
                />
            );
        }
        return bars;
    };

    return (
        <div 
            ref={containerRef}
            className="volume-indicator"
            style={{ width: `${width}px`, height: `${height}px` }}
        >
            {renderBars()}
        </div>
    );
};

export default VolumeIndicator;
